// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiTableSortLabel from '@mui/material/TableSortLabel';
import { colors } from '@custom-components';
import { StyledSVGIcon } from './SelectTable.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

class TableSortLabel extends Component {
  constructor(props) {
    super(props);
    this.renderSVGIcon = this.renderSVGIcon.bind(this);
  }

  renderSVGIcon() {
    const { direction, active } = this.props;
    return direction === 'asc' ? (
      <StyledSVGIcon selectedIcon="arrow" iconColor={active ? colors.colorBlue : colors.colorGrey02} width="10px" />
    ) : (
      <StyledSVGIcon
        selectedIcon="arrow"
        iconColor={active ? colors.colorBlue : colors.colorGrey03}
        width="10px"
        rotate={180}
      />
    );
  }

  render() {
    const { children, ...other } = this.props;

    return (
      <MuiTableSortLabel {...other} IconComponent={this.renderSVGIcon}>
        {children}
      </MuiTableSortLabel>
    );
  }
}

TableSortLabel.propTypes = {
  /** Direction to sort - asc or desc */
  direction: PropTypes.oneOf(['asc', 'desc']),
  /** Content inside sort label */
  children: ReactChildrenPropType.isRequired,
  /** Shows if sort label is in use */
  active: PropTypes.bool.isRequired,
  /** Hide icon beside label */
  hideSortIcon: PropTypes.bool
};

TableSortLabel.defaultProps = {
  direction: 'asc',
  hideSortIcon: false
};

export default TableSortLabel;
